import { ref } from 'vue';

import { usePostMessageReceiver } from '@/composables/usePostMessageReceiver';

const { onSendPubnubActualId } = usePostMessageReceiver();

export const buyerPubnubActualId = ref<string | undefined>();

onSendPubnubActualId((data: { pn_actual_id: string }) => {
  buyerPubnubActualId.value = data.pn_actual_id;
});
